import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const paymentService = {
  async getAllPayments() {
    try {
      const response = await axios.get(`${API_URL}/payments`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getPaymentById(id) {
    try {
      const response = await axios.get(`${API_URL}/payments/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getPaymentsByDoctor(doctorId) {
    try {
      const response = await axios.get(
        `${API_URL}/payments/doctor/${doctorId}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createPayment(paymentData) {
    try {
      const response = await axios.post(
        `${API_URL}/payments`,
        paymentData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deletePayment(id) {
    try {
      const response = await axios.delete(`${API_URL}/payments/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default paymentService;
